import { Group, GroupProps } from '@mantine/core';
import classes from './ServiceBaseRow.module.css';

export default function ServiceBaseRow({
  children = null,
  ...props
}: {
  children?: React.ReactNode;
} & GroupProps) {
  return (
    <Group className={classes.serviceRow} gap={0} wrap="nowrap" {...props}>
      {children}
    </Group>
  );
}
